import { hotTitles } from "@/mocks/contest";

const medalColors = [
  "bg-foreground-900 text-background-50",
  "bg-secondary-400 text-background-50",
  "bg-primary-200 text-primary-900",
];

export default function Ranking() {
  return (
    <section id="rank" className="scroll-mt-20 bg-foreground-950 py-14 text-background-50 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="flex items-center gap-2 text-sm font-bold tracking-wide text-secondary-300">
              <i className="ri-fire-fill" />
              每周热榜
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-background-50 md:text-3xl">
              本周全网围观人气王
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              根据每日大赛全网围观与点赞数据综合生成，看看这周哪条沙雕赛报把人笑到停不下来。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-xs text-background-200">
            <i className="ri-refresh-line" />
            每周一 00:00 更新
          </span>
        </div>

        <div className="mt-9 grid gap-5 lg:grid-cols-3">
          {hotTitles.slice(0, 3).map((item) => (
            <div
              key={item.rank}
              className={`relative overflow-hidden rounded-3xl p-6 ${medalColors[item.rank - 1]} md:p-7`}
            >
              <i className="absolute -right-3 -top-3 text-7xl opacity-15 ri-trophy-fill" />
              <p className="text-4xl font-black leading-none opacity-90">0{item.rank}</p>
              <h3 className="mt-5 text-lg font-bold leading-snug">{item.title}</h3>
              <p className="mt-3 inline-flex items-center gap-1.5 text-sm text-background-200">
                <i className="ri-eye-fill" />
                {item.count}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-5 overflow-hidden rounded-3xl border border-background-50/10 bg-background-50/5">
          <ul className="divide-y divide-background-50/10">
            {hotTitles.slice(3).map((item) => (
              <li key={item.rank}>
                <a
                  href="#mi"
                  className="group flex items-center gap-4 px-5 py-4 transition hover:bg-background-50/10 md:px-6"
                >
                  <span className="w-6 text-center text-sm font-black text-background-400 group-hover:text-secondary-300">
                    {item.rank}
                  </span>
                  <span className="h-2 w-2 rounded-full bg-accent-400" />
                  <span className="flex-1 truncate text-sm font-medium text-background-100 transition group-hover:text-background-50 md:text-base">
                    {item.title}
                  </span>
                  <span className="hidden shrink-0 items-center gap-1 text-xs text-background-300 sm:inline-flex">
                    <i className="ri-eye-line" />
                    {item.count}
                  </span>
                  <i className="ri-arrow-right-up-line text-background-400 transition group-hover:text-secondary-300" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}